import { createContext, useContext, useState, useEffect } from 'react';
import * as authService from '../services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [auth, setAuthState] = useState({
        email: null,
        role: null,
        isLoggedIn: false,
    });

    // On page load restore UI state from localStorage.
    // The httpOnly cookie is validated server-side on the first API request.
    useEffect(() => {
        const email = authService.getEmail();
        const role = authService.getRole();
        if (email) {
            setAuthState({ email, role, isLoggedIn: true });
        }
    }, []);

    const login = async (email, password) => {
        const data = await authService.login(email, password);
        setAuthState({ email: data.email, role: data.role, isLoggedIn: true });
        return data;
    };

    const register = async (email, password) => {
        const data = await authService.register(email, password);
        setAuthState({ email: data.email, role: data.role, isLoggedIn: true });
        return data;
    };

    const loginWithGoogle = async (credential) => {
        const data = await authService.loginWithGoogle(credential);
        setAuthState({ email: data.email, role: data.role, isLoggedIn: true });
        return data;
    };

    // Calls POST /api/auth/logout so the server clears the httpOnly cookie,
    // then wipes local UI state.
    const logout = async () => {
        await authService.logout();
        setAuthState({ email: null, role: null, isLoggedIn: false });
    };

    return (
        <AuthContext.Provider value={{ ...auth, login, logout, register, loginWithGoogle }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
